
import { defineComponent } from 'vue';
import { ElementMixin } from 'vue-slicksort';

export default defineComponent({
  name: 'SortableItem',
  mixins: [ElementMixin as any],
});
